import { render, staticRenderFns } from "./ShareButtons.vue?vue&type=template&id=138f9666&scoped=true&"
import script from "./ShareButtons.vue?vue&type=script&lang=ts&"
export * from "./ShareButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ShareButtons.vue?vue&type=style&index=0&id=138f9666&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f9666",
  null
  
)

export default component.exports